export const ACTUALIZAR_DISTRIBUCIONES = "ACTUALIZAR_DISTRIBUCIONES";
export const ACTUALIZAR_SUBCUENTAS_DISTRIBUCION = "ACTUALIZAR_SUBCUENTAS_DISTRIBUCION";
export const ACTUALIZAR_DISTRIBUCIONES_DB = "ACTUALIZAR_DISTRIBUCIONES_DB";
export const CARGANDO_DISTRIBUCIONES = "CARGANDO_DISTRIBUCIONES";
export const ERROR_DISTRIBUCIONES = "ERROR_DISTRIBUCIONES";
export const LIMPIAR_ERROR_DISTRIBUCIONES = "LIMPIAR_ERROR_DISTRIBUCIONES";
